import React from 'react';
import _ from 'lodash';
var Api = require('./Config');

/**
 * This is used by Review Portal to allow printing of 
 * external pdf documents by TS
 */
export default class ExternalFaxSend2 extends React.Component {
  getParameterByName(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  constructor(props) {
    super(props);
    this.state = {
      PMHID: null,
      token: null
    };
    this.myRef = React.createRef();
  }

  componentDidMount() {
    const PMHID = _.get(this, 'props.match.params.PMHID', this.props.PMHID);
    const token = this.getParameterByName('token') || '';
    this.setState({
      PMHID: PMHID,
      token: token
    });

    /**
     * Allow print of external pdf from review portal
     */
    window.addEventListener('message', ({ data }) => data === 'print' && this.myRef.current.contentWindow.print());
  }

  render() {
    const url = `${Api.getHost()}docportal_api/services/get_ts_file.php?PMHID=${this.state.PMHID}&token=${this.state.token}`;

    return (
      <div>
        <iframe src={url} style={{width: "100%", height: "100%", position: "absolute", top: 0, left: 0}} ref={this.myRef}/>
      </div>
    );
  }
}
